import LegacyAnalyticsListener from './LegacyAnalyticsListener';
import ModernAnalyticsListener from './ModernAnalyticsListener';
let ExportedAnalyticsListener;

if (typeof process !== 'undefined' && process.env['ANALYTICS_NEXT_MODERN_CONTEXT']) {
  ExportedAnalyticsListener = ModernAnalyticsListener;
} else {
  ExportedAnalyticsListener = LegacyAnalyticsListener;
}

export default ExportedAnalyticsListener;